// const lenis = new Lenis({
//   inertia: 0.1
// });

// lenis.on('scroll', (e) => {
//   // console.log(e)
// })

// function raf(time) {
//   lenis.raf(time)
//   requestAnimationFrame(raf)
// }

// requestAnimationFrame(raf);

var $ = jQuery.noConflict();
jQuery(document).ready(function () {
  wowo(jQuery);
  headerMenu();
  headercart();
  accordion();
  htmladdClass();
  video();
  slider();
  selectarrow();
  selfsettingheight();
  tabcardchoose();
  updateSlickDotsPosition();
  getlink();
  twocloumntextchange();
  customSelect();
  labelup();
  copy();
  copyBtn();
  parallax();
  filtercardshow();
  expandablecardsshow();
  productdetailstabchange();
  scrollproductdetails();
  linksaddclass();
  emailchecked();
  searchclick();
  pageInnerScroll();

  jQuery("body").on("click", "a.btn", function (e) {
    var $link = jQuery(this);
    var href = $link.attr("href");

    if (href && href.startsWith("#") && href.length > 1) {
      e.preventDefault();

      var $target = jQuery(href);
      if ($target.length) {
        var $header = jQuery("header");
        var sTop = $header.length ? $header.outerHeight() : 0;
        var targetOffset = $target.offset().top;

        jQuery("html, body").stop().animate(
          { scrollTop: targetOffset - sTop },
          800
        );
      }
    }
  });
});

let scrollY = window.scrollY;

jQuery(window).scroll(function () {
  wowo(jQuery);
  parallax();

  if (jQuery(document).scrollTop() > 30) {
    jQuery('header').addClass('sticky');
  } else {
    jQuery('header').removeClass('sticky');
  }

  let currentY = window.scrollY;

  scrollY = currentY;
});

jQuery(window).resize(function () {
  selfsettingheight();
  updateSlickDotsPosition();
  headerMenu();
});

function wowo($) {
  jQuery('html').addClass("show-c");

  setTimeout(function () {
    var wTop = jQuery(window).scrollTop(), wHeight = jQuery(window).height(), wBottom = wTop + wHeight;
    jQuery(".wowo:not(.animated)").each(function () {
      var me = jQuery(this), meTop = me.offset().top, meHeight = me.height(), meBottom = meTop + meHeight,
        limitTop = wTop - meHeight, limitBottom = wBottom + meHeight;
      if (meTop > limitTop && meBottom < limitBottom) {
        me.addClass("animated");
        setTimeout(function () {
          me.removeClass("animated wowo");
        }, 1500);
      }
    })
  }, 100);
}

function headerMenu() {
  // Mobile
  jQuery(document).ready(function ($) {
    $(".burger").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      $("html").addClass("overflow-hidden");
      $('header .mobile-navbar-menu').addClass('active');
      $("header").addClass('active');
    });

    $('body').on('click', '.mobile-navbar-menu .menu-item-has-children .title-box span', function (e) {
      e.preventDefault();
      e.stopPropagation();

      $("html").addClass("overflow-hidden");
      $(this).closest('.menu-item-has-children')
        .find('.sub-nav')
        .addClass('active');
    });

    $(".mobile-navbar-menu .sub-nav .back").on("click", function (e) {
      e.stopPropagation();
      $("html").addClass("overflow-hidden");
      $(this).closest('.sub-nav').removeClass('active');
    });

    $(".mobile-sticky-bar .close-btn").on("click", function (e) {
      e.stopPropagation();
      closeMobileMenu();
    });

    $(document).on('click', function (e) {
      if (!$(e.target).closest('.mobile-navbar-menu .content').length &&
        !$(e.target).closest('.burger').length) {
        closeMobileMenu();
      }
    });

    function handleResize() {
      if ($(window).width() >= 1201) {
        closeMobileMenu();
      }
    }

    function closeMobileMenu() {
      $("html").removeClass("overflow-hidden");
      $('header .mobile-navbar-menu').removeClass('active');
      $("header").removeClass('active');
      $(".mobile-navbar-menu .sub-nav").removeClass("active");
    }

    handleResize();
    $(window).on('resize', handleResize);
  });

  // PC
  jQuery("header .menu-item-has-children").on("mouseenter", function (e) {
    if (jQuery(window).width() >= 1201) {
      jQuery("header .sub-nav").not(jQuery(this).find(".sub-nav")).stop(true, true).fadeOut(200);
      jQuery("header").addClass('active');

      jQuery(this).addClass('hovered');

      var $subNav = jQuery(this).find(".sub-nav");
      $subNav.stop(true, true).fadeIn(300);
    }
  });

  jQuery("header .menu-item-has-children").on("mouseleave", function (e) {
    if (jQuery(window).width() >= 1201) {
      if (!jQuery(this).has(e.relatedTarget).length) {
        jQuery(this).removeClass('hovered');
        jQuery(this).find(".sub-nav").stop(true, true).delay(100).fadeOut(300);
        jQuery("header").removeClass('active');
      }
    }
  });

  jQuery("header .sub-nav").on("mouseleave", function (e) {
    if (jQuery(window).width() >= 1201) {
      var $parentItem = jQuery(this).closest('.menu-item-has-children');
      if (!$parentItem.has(e.relatedTarget).length) {
        $parentItem.removeClass('hovered');
        jQuery(this).stop(true, true).fadeOut(300);
        jQuery("header").removeClass('active');
      }
    }
  });

  jQuery("header .sub-nav").on("click", function (e) {
    e.stopPropagation();
  });

  jQuery("header").on("mouseleave", function (e) {
    if (jQuery(window).width() >= 1201) {
      jQuery("header .sub-nav").stop(true, true).fadeOut(300);
      jQuery("header .menu-item-has-children").removeClass('hovered');
      jQuery("header").removeClass('active');
    }
  });
}

function selfsettingheight() {
  try {
    // headerHeight
    const $stickyBar = $('.sticky-bar');
    const $header = $('.header');

    if ($stickyBar.length && $header.length) {
      const stickybarHeight = $stickyBar.outerHeight() || 0;
      const headerHeight = $header.outerHeight() || 0;
      document.documentElement.style.setProperty('--header-height', (stickybarHeight + headerHeight) + 'px');
    }

    // mobilestickybarHeight
    const $mobileStickyBar = $('.header .mobile-navbar-menu .mobile-sticky-bar');
    if ($mobileStickyBar.length) {
      const mobilestickybarHeight = $mobileStickyBar.outerHeight() || 0;
      document.documentElement.style.setProperty('--mobilestickybarHeight', mobilestickybarHeight + 'px');
    }

    // comment-card-slider
    const $commentSlider = $('.comment-card-slider');
    if ($commentSlider.length) {
      const $cardBox = $commentSlider.find('.slider-box .card-box');
      const $slickNext = $cardBox.find('.slick-next');

      if ($cardBox.length && $slickNext.length) {
        const commentcardsliderwidth = $cardBox.outerWidth() || 0;
        const commentcardslidernextwidth = $slickNext.outerWidth() || 0;
        const commentcardsliderbottom = $cardBox.parent().css('padding-bottom');

        const $titleBox = $commentSlider.find('.title-box');
        if ($titleBox.length) {
          const titleBoxRight = $titleBox.offset().left + $titleBox.outerWidth();
          const cardBoxLeft = $cardBox.offset().left;
          const spacing = cardBoxLeft - titleBoxRight;
          const commentcardslidernext = commentcardsliderwidth + spacing;
          const commentcardsliderprev = commentcardslidernext + commentcardslidernextwidth + 12;

          const isLargeScreen = $(window).width() < 1350;

          const rightOffsetPrev = isLargeScreen ? commentcardsliderprev : commentcardsliderprev + 55;
          const rightOffsetNext = isLargeScreen ? commentcardslidernext : commentcardslidernext + 55;

          $cardBox.find('.slick-prev')
            .css('bottom', commentcardsliderbottom)
            .css('right', rightOffsetPrev + 'px');

          $slickNext
            .css('bottom', commentcardsliderbottom)
            .css('right', rightOffsetNext + 'px');
        }
      }
    }
  } catch (error) {
    console.error('Error in safeSelfSettingHeight:', error);
  }

  const $sliderBox = $('.comment-card-slider .slider-box');
  const $cardBox = $('.comment-card-slider .slider-box .title-box').outerWidth();

  function updateCommentWidth() {
    if ($sliderBox.length && $cardBox.length) {
      const viewportWidth = window.innerWidth;
      const commentwidth = viewportWidth - $cardBox;
      document.documentElement.style.setProperty('--commentwidth', commentwidth + 'px');
    }
  }

  updateCommentWidth();
  window.addEventListener('resize', updateCommentWidth);
}

function headercart() {
  var cartIconBubble = jQuery('#cart-icon-bubble');
  var cartCountBubble = cartIconBubble.find('.cart-count-bubble');

  if (cartCountBubble.length > 0) {
    cartIconBubble.addClass('newClass');
  } else {
    cartIconBubble.removeClass('newClass');
  }

  setInterval(function () {
    cartCountBubble = cartIconBubble.find('.cart-count-bubble');
    if (cartCountBubble.length > 0) {
      cartIconBubble.addClass('newClass');
    } else {
      cartIconBubble.removeClass('newClass');
    }
  }, 1000);
}

function htmladdClass() {
  jQuery('#cart-icon-bubble').on('click', function (e) {
    e.stopPropagation();
    jQuery('html').addClass('overflow-hidden');

    jQuery('.header .container .header-right ul li .search-button').removeClass('is-click');
    jQuery('.header__search ').removeClass('open');
  });

  jQuery('.product-details .product-form__buttons').on('click', function (e) {
    e.stopPropagation();
    jQuery('html').addClass('overflow-hidden');

    jQuery('.header .container .header-right ul li .search-button').removeClass('is-click');
    jQuery('.header__search ').removeClass('open');
  });

  jQuery('.media-back button').on('click', function (e) {
    e.stopPropagation();
    jQuery('html').addClass('overflow-hidden');

    jQuery('.header .container .header-right ul li .search-button').removeClass('is-click');
    jQuery('.header__search ').removeClass('open');
  });

  jQuery('.drawer__close').on('click', function (e) {
    e.stopPropagation();
    jQuery('html').removeClass('overflow-hidden');
  });

  jQuery('.drawer__inner,.drawer__footer,cart-drawer-items').on('click', function (e) {
    e.stopPropagation();
  });

  jQuery('body').on('click', function (e) {
    jQuery('html').removeClass('overflow-hidden');
  });
}

function video() {
  // var videoElements = document.querySelectorAll('video');
  // videoElements.forEach(function (videoElement) {
  //   var videoSrc = videoElement.getAttribute('src');
  //   if (videoSrc && videoSrc.endsWith('.mp4')) {
  //   } else {
  //     var hls = new Hls();
  //     hls.loadSource(videoSrc);
  //     hls.attachMedia(videoElement);
  //   }
  // });
}

function accordion() {
  jQuery('.accordion .item .item-head').on('click', function (e) {
    jQuery(this).toggleClass('active');
    jQuery(this).siblings().slideToggle(300);
    jQuery(this).parents().siblings().find('.item-body').slideUp(300);
    jQuery(this).parents().siblings().find('.item-head').removeClass('active');
  })

  let lis = jQuery(".accordion li");

  jQuery(".accordion li").click(function () {
    lis.removeClass("currentopen");
    jQuery(this).addClass("currentopen");
  });

  jQuery(document).ready(function ($) {
    $('.footer-menu .menu-item-has-children > p').on('click', function (e) {
      if ($(window).width() < 769) {
        e.preventDefault();
        var $thisP = $(this);
        var $thisSubMenu = $thisP.next('.sub-menu');

        $('.footer-menu .menu-item-has-children > p').not($thisP)
          .removeClass('active')
          .next('.sub-menu').slideUp(300);

        $thisP.toggleClass('active');
        $thisSubMenu.slideToggle(300);
      }
    });
  });
}

function slider() {
  function debounce(func, wait = 100) {
    let timeout;
    return function () {
      const context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(context, args);
      }, wait);
    };
  }

  $(document).ready(function () {
    var $wrapper = $('.swiper-wrapper');
    var $cards = $('.swiper-slide');
    $cards.clone().appendTo($wrapper);

    var cardWidth = $('.card').outerWidth(true);
    var cardCount = $('.swiper-slide').length;
    var originalCardCount = cardCount / 2;
    $wrapper.css('width', cardWidth * cardCount + 'px');

    var animation;
    var duration = 13000;
    var currentPosition = 0;
    var isPaused = false;

    var totalDistance = cardWidth * originalCardCount;
    var startTime;

    function animate(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = timestamp - startTime;

      if (!isPaused) {
        currentPosition = -totalDistance * (progress / duration);

        if (progress >= duration) {
          currentPosition = 0;
          startTime = timestamp;
        }

        $wrapper.css('transform', 'translateX(' + currentPosition + 'px)');
      }

      animation = requestAnimationFrame(animate);
    }

    animation = requestAnimationFrame(animate);

    $('.card-box').hover(
      function () {
        isPaused = true;
      },
      function () {
        isPaused = false;
        startTime = performance.now() - (duration * (-currentPosition / totalDistance));
      }
    );

    $(window).resize(function () {
      cardWidth = $('.card').outerWidth(true);
      $wrapper.css('width', cardWidth * cardCount + 'px');
    });
  });

  var slickInitialized = false;
  function initProductSliders() {
    const $bigSlider = jQuery('.product-details .left-box .big-media-box');
    const $smallSlider = jQuery('.product-details .left-box .small-media-box');
    const isMobileView = jQuery(window).width() < 992;

    const smallSlideCount = $smallSlider.length;

    if ($bigSlider.length > 0 && $smallSlider.length > 0) {
      if (isMobileView && !slickInitialized) {
        $bigSlider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          autoplay: false,
          pauseOnHover: false,
          pauseOnFocus: true,
          infinite: true,
          speed: 500,
          autoplaySpeed: 5000,
          adaptiveHeight: true,
          asNavFor: smallSlideCount > 3 ? '.product-details .left-box .small-media-box' : null,
        });

        $smallSlider.slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          focusOnSelect: true,
          autoplay: false,
          pauseOnHover: false,
          pauseOnFocus: true,
          infinite: true,
          speed: 500,
          autoplaySpeed: 5000,
          adaptiveHeight: true,
          asNavFor: '.product-details .left-box .big-media-box',
        });

        slickInitialized = true;
      } else if (!isMobileView && slickInitialized) {
        $bigSlider.slick('unslick');
        $smallSlider.slick('unslick');
        slickInitialized = false;
      }
    }
  }

  var slickInitialized2 = false;
  function tabcardslider() {
    const $textCard = jQuery('.tab-card-slider .card-slider-box .slider-box');
    const isMobileView = jQuery(window).width() <= 767;

    if ($textCard.length > 0) {
      if (isMobileView && !slickInitialized2) {
        $textCard.slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          autoplay: false,
          pauseOnHover: false,
          pauseOnFocus: true,
          infinite: false,
          draggable: true,
          speed: 500,
          autoplaySpeed: 5000,
          responsive: [
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });
        slickInitialized2 = true;
      } else if (!isMobileView && slickInitialized2) {
        $textCard.slick('unslick');
        slickInitialized2 = false;
      }
    }
  }

  var slickInitialized3 = false;
  function threecardbox() {
    const $textCard = jQuery('.three-card-box .card-box');
    const isMobileView = jQuery(window).width() <= 991;

    if ($textCard.length > 0) {
      if (isMobileView && !slickInitialized3) {
        $textCard.slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          autoplay: false,
          pauseOnHover: false,
          pauseOnFocus: true,
          infinite: true,
          draggable: true,
          speed: 500,
          autoplaySpeed: 5000,
          responsive: [
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });
        slickInitialized3 = true;
      } else if (!isMobileView && slickInitialized3) {
        $textCard.slick('unslick');
        slickInitialized3 = false;
      }
    }
  }

  initProductSliders();
  tabcardslider();
  threecardbox();

  const debounceResize = debounce(() => {
    initProductSliders();
    tabcardslider();
    threecardbox();
  }, 100);

  window.addEventListener('resize', debounceResize);
}

function updateSlickDotsPosition() {
  if (window.innerWidth < 768) return;

  const tabcardtoolHeight = $('.tab-card-slider .tab-card-tool').outerHeight();
  const cardsliderboxMarginBottom = parseFloat($('.tab-card-slider .card-slider-box').css('margin-bottom'));
  const prevwidth = $('.tab-card-slider .card-slider-box .slider-box .slick-prev').outerWidth();
  const nextwidth = $('.tab-card-slider .card-slider-box .slider-box .slick-prev').outerWidth();
  const prevright = prevwidth + 12;
  const dotsbottom = -((tabcardtoolHeight / 2) + cardsliderboxMarginBottom + 5);
  const dotsright = nextwidth + prevright + 31;
  const arrowbottom = -(tabcardtoolHeight + cardsliderboxMarginBottom);

  $('.tab-card-slider .card-slider-box .slider-box.active .slick-dots')
    .css('bottom', `${dotsbottom}px`)
    .css('right', `${dotsright}px`);

  $('.tab-card-slider .card-slider-box .slider-box.active .slick-prev')
    .css('bottom', `${arrowbottom}px`)
    .css('right', `${prevright}px`);

  $('.tab-card-slider .card-slider-box .slider-box.active .slick-next')
    .css('bottom', `${arrowbottom}px`);
}

function tabcardchoose() {
  $('.tab-choose-box .tab').first().addClass('active');
  $('.tab-card-slider .title-box .tab-box .tab').first().addClass('active');

  $('.card-slider-box .slider-box').first().addClass('active').show();

  $('.tab-choose-box .tab').on('click', function () {
    if ($(this).hasClass('active')) return;

    const tabIndex = $(this).index();

    $('.tab-choose-box .tab,.tab-card-slider .title-box .tab-box .tab').removeClass('active');
    $(this).addClass('active');

    $('.card-slider-box .slider-box.active').fadeOut(300, function () {
      $(this).removeClass('active');
      $('.card-slider-box .slider-box').eq(tabIndex)
        .addClass('active')
        .fadeIn(300);

      jQuery(document).ready(function ($) {
        function debounce(func, wait) {
          let timeout;
          return function () {
            clearTimeout(timeout);
            timeout = setTimeout(func, wait);
          };
        }

        function refreshSlickOnMobile() {
          if ($(window).width() <= 768) {
            $('.card-slider-box .slider-box').slick('refresh');
          }
        }

        refreshSlickOnMobile();

        $(window).on('resize', debounce(refreshSlickOnMobile, 250));
      });

      updateSlickDotsPosition();
    });
  });

  $('.tab-card-slider .title-box .tab-box .tab').on('click', function () {
    if ($(this).hasClass('active')) return;

    const tabIndex = $(this).index();

    $('.tab-card-slider .title-box .tab-box .tab').removeClass('active');
    $(this).addClass('active');

    $('.card-slider-box .slider-box.active').fadeOut(300, function () {
      $(this).removeClass('active');
      $('.card-slider-box .slider-box').eq(tabIndex)
        .addClass('active')
        .fadeIn(300);

      jQuery(document).ready(function ($) {
        function debounce(func, wait) {
          let timeout;
          return function () {
            clearTimeout(timeout);
            timeout = setTimeout(func, wait);
          };
        }

        function refreshSlickOnMobile() {
          if ($(window).width() <= 768) {
            $('.card-slider-box .slider-box').slick('refresh');
          }
        }

        refreshSlickOnMobile();

        $(window).on('resize', debounce(refreshSlickOnMobile, 250));
      });

      updateSlickDotsPosition();
    });
  });
}

function selectarrow() {
  jQuery('.product-details .product-details-text variant-selects select').on('click', function (e) {
    jQuery('.product-form__input .select').addClass('active');
  });

  jQuery('body').on('click', '.product-details .product-details-text variant-selects select', function (e) {
    e.stopPropagation();
    jQuery(this).parents('.select').toggleClass('open');
  })

  jQuery('.product-details .product-details-text variant-selects select option').click(function () {
    jQuery(this).parents('.select').removeClass('open');
  });

  jQuery('body').click(function () {
    jQuery('.select').removeClass('open');
  });
}

function getlink() {
  if (jQuery('.faqs-model .right-box .content-box h2').length) {
    var count = 0;
    jQuery('.faqs-model .right-box .content-box h2').each(function () {
      let anchorText = jQuery(this).text().trim().replace(/^\d+\.\s*/, ''),
        anchorLink = anchorText.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

      if (!anchorLink) {
        anchorLink = 'heading-' + count;
      }

      jQuery(this).attr('id', anchorLink);
      jQuery('.jumplinks ul').append(`<li id="jumplink-${anchorLink}"><a href="#${anchorLink}">${anchorText}</a></li>`);
      count++;
    });
  } else {
    jQuery('.faqs-model .jumplinks ul').remove();
  }

  let isScrolling = false;

  jQuery('.jumplinks ul li a').on('click', function (e) {
    e.preventDefault();
    var targetElement = jQuery(this.hash);

    if (targetElement.length) {
      isScrolling = true;
      var sTop = jQuery('header').outerHeight();

      var targetOffset = targetElement.offset()?.top;

      if (typeof targetOffset !== 'undefined') {
        jQuery('html,body').animate(
          { scrollTop: targetOffset - sTop },
          800,
          function () {
            isScrolling = false;
          }
        );
      }

      jQuery('.jumplinks ul li a').removeClass('active');
      jQuery('.jumplinks ul li').removeClass('active');
      jQuery(this).addClass('active');
      jQuery(this).parent().addClass('active');
    }
  });

  if (window.location.hash) {
    var targetElement = jQuery(window.location.hash);

    if (targetElement.length) {
      var sTop = jQuery('header').outerHeight();
      var targetOffset = targetElement.offset()?.top;

      if (typeof targetOffset !== 'undefined') {
        jQuery('html, body').animate({ scrollTop: targetOffset - sTop }, 800);
      }
    }
  }

  jQuery(window).on('scroll', function () {
    if (isScrolling) return;

    var sTop = jQuery('header').outerHeight();
    var scrollMiddle = jQuery(window).scrollTop() + (jQuery(window).height() / 3);
    var windowBottom = jQuery(window).scrollTop() + jQuery(window).height();
    var docHeight = jQuery(document).height();

    var activeId = null;
    var firstHeading = jQuery('h2').first();
    var lastHeading = jQuery('h2').last();

    jQuery('h2').each(function () {
      var section = jQuery(this);
      var sectionTop = section.offset()?.top;

      if (typeof sectionTop !== 'undefined' && scrollMiddle >= sectionTop) {
        activeId = section.attr('id');
      }
    });

    if (jQuery(window).scrollTop() === 0) {
      activeId = firstHeading.attr('id');
    }

    if (windowBottom >= docHeight - 10) {
      activeId = lastHeading.attr('id');
    }

    if (activeId) {
      jQuery('.jumplinks ul li a').removeClass('active');
      jQuery('.jumplinks ul li').removeClass('active');

      jQuery(`.jumplinks ul li a[href="#${activeId}"]`).addClass('active');
      jQuery(`#jumplink-${activeId}`).addClass('active');
    }
  });
}

function twocloumntextchange() {
  $('.two-cloumn-text .left-box .tool-box .jumplinks ul li').first().addClass('active');
  $('.two-cloumn-text .right-box .content-box').first().addClass('active').show();

  $('.two-cloumn-text .left-box .tool-box .jumplinks ul li').on('click', function () {
    if ($(this).hasClass('active')) return;

    const tabIndex = $(this).index();

    const linkText = $(this).find('a').text();
    $('.breadcrumb-item:last-child p').text(linkText);

    $('.two-cloumn-text .left-box .tool-box .jumplinks ul li').removeClass('active');
    $(this).addClass('active');

    $('.two-cloumn-text .right-box .content-box.active').fadeOut(300, function () {
      $(this).removeClass('active');
      $('.two-cloumn-text .right-box .content-box').eq(tabIndex)
        .addClass('active')
        .fadeIn(300);
    });
  });
}

function customSelect() {
  jQuery('body').on('click', '.is-select input', function (e) {
    e.stopPropagation();
    jQuery(this).parents('.is-select').toggleClass('open');
    jQuery(this).parents('.is-select').find('ul').slideToggle(200);
  })

  jQuery('.is-select ul li a').click(function () {
    jQuery(this).parents('.is-select').removeClass('open');
    jQuery(this).parents('.is-select').find('ul').slideUp(200);
    var value = jQuery(this).text();
    jQuery(this).parents('.is-select').find('input').val(value);
  });

  jQuery('body').click(function () {
    jQuery('.is-select').removeClass('open');
    jQuery('.is-select').find('ul').slideUp(200);
  });
}

function labelup() {
  jQuery(document).on("focus", "input[type=email]", function () {
    jQuery(this).siblings('label').addClass("active");
  });

  jQuery(document).on("blur change", "input[type=email]", function () {
    var isEmpty = !jQuery(this).val();
    jQuery(this).siblings('label').toggleClass("active", !isEmpty);
  });
}

function copy(copy_val) {
  const input = document.createElement('input');
  input.setAttribute('readonly', 'readonly');
  input.setAttribute('value', copy_val);
  document.body.appendChild(input);
  input.setSelectionRange(0, 9999);
  input.select();
  document.execCommand('copy');
  document.body.removeChild(input);
}

function copyBtn() {
  let _this = this;
  jQuery('body').on('click', '.icon-Share', function (e) {
    e.preventDefault();
    if (!jQuery(this).hasClass('copied')) {
      let value = window.location.href;
      _this.copy(value);
      jQuery(this).addClass('copied');
      setTimeout(() => {
        jQuery(this).removeClass('copied');
      }, 1000);
    }
  })
}

function parallax() {
  if (jQuery(window).width() > 991) {
    var wh = jQuery(window).height();
    var sh = jQuery(window).scrollTop();

    jQuery(".parallax").each(function () {
      var parallax_h = jQuery(this).offset().top;
      var item_h = jQuery(this).outerHeight();
      var parallax_y;
      if (sh > (parallax_h - wh) && sh < parallax_h + item_h) {
        parallax_y = 100 * (sh - (parallax_h - wh)) / (wh + item_h);
      }
      jQuery(this).css('transform', 'translateY(' + parallax_y + '%)');
    });

    jQuery(".parallax-r").each(function () {
      var parallax_h = jQuery(this).offset().top;
      var item_h = jQuery(this).outerHeight();
      var parallax_y;
      if (sh > (parallax_h - wh) && sh < parallax_h + item_h) {
        parallax_y = (item_h / 10) * ((parallax_h - wh) - sh) / (wh + item_h);
      }
      jQuery(this).css('transform', 'translateY(' + parallax_y + '%)');
    });

    jQuery(".parallax-x").each(function () {
      var parallax_h = jQuery(this).offset().top;
      var item_h = jQuery(this).outerHeight();
      var parallax_y;
      if (sh > (parallax_h - wh) && sh < parallax_h + item_h) {
        parallax_y = 30 * ((parallax_h - wh) - sh) / (wh + item_h);
      }
      jQuery(this).css('transform', 'translateY(' + parallax_y + '%)');
    });

    jQuery(".parallax-z").each(function () {
      var parallax_h = jQuery(this).offset().top;
      var item_h = jQuery(this).outerHeight();
      var parallax_y;
      if (sh > (parallax_h - wh) && sh < parallax_h + item_h) {
        parallax_y = 30 * (sh - (parallax_h - wh)) / (wh + item_h);
      }
      jQuery(this).css('transform', 'translateY(' + parallax_y + '%)');
    });
  } else {
    jQuery('.parallax').css('transform', 'translateY(0)');
  }
}

function filtercardshow() {
  $(document).ready(function () {
    $(document).on('click', function (e) {
      if (!$(e.target).closest('.mobile-facets__inner').length &&
        !$(e.target).closest('.mobile-facets__open').length) {

        const $disclosure = $('.mobile-facets__disclosure.disclosure-has-popup');

        $disclosure.removeClass('menu-opening');

        setTimeout(() => {
          $disclosure.removeAttr('open');
        }, 300);

        $('.mobile-facets__open-wrapper.focus-offset')
          .attr('aria-expanded', 'false');

        $('body').removeClass('overflow-hidden-mobile');
      }
    });

    $('.mobile-facets__inner').on('click', function (e) {
      e.stopPropagation();
    });
  });
}

function expandablecardsshow() {
  $('.expandable-cards .btn:not(.style-black)').on('click', function (e) {
    e.preventDefault();

    var $textBox = $(this).closest('.content-right').find('.text-box');
    var $btn = $(this);
    var collapsedHeight = $(window).width() < 768 ? '315px' : '274px';

    $textBox.toggleClass('active');

    if ($textBox.hasClass('active')) {
      $textBox.css('max-height', $textBox[0].scrollHeight + 'px');
      $btn.html('<span class="icon-less"></span>Show less');
      $textBox.css('background-image', 'none');
    } else {
      $textBox.css('max-height', collapsedHeight);
      $btn.html('<span class="icon-add"></span>Read more');
      $textBox.css('background-image', 'linear-gradient(to top, #f4f3f0, rgba(244, 243, 240, 0))');
    }

    $textBox.find('p, h3, ul').css('opacity', 0).animate({ opacity: 1 }, 300);
  });

  $(window).on('resize', function () {
    var collapsedHeight = $(window).width() < 768 ? '315px' : '274px';
    $('.expandable-cards .text-box:not(.active)').css('max-height', collapsedHeight);
  });
}

function productdetailstabchange() {
  $('.product-details .tab-title a').click(function (e) {
    e.preventDefault();

    var tabIndex = $(this).index();

    $('.product-details .tab-title a').removeClass('active');
    $(this).addClass('active');

    $('.product-details .tab-content .item').removeClass('active').hide();

    $('.product-details .tab-content .item').eq(tabIndex).addClass('active').fadeIn(300);

  });

  if ($('.product-details .tab-title a.active').length === 0) {
    $('.product-details .tab-title a:first').addClass('active');
    $('.product-details .tab-content .item:first').addClass('active').show();
  }
}

function scrollproductdetails() {
  if (jQuery(window).width() >= 992) {
    const $smallImgs = $('.product-details .small-media-box .img');
    const $bigImgs = $('.product-details .big-media-box .img');
    const $bigMediaBox = $('.product-details .big-media-box');
    const $productDetails = $('.product-details');

    let scrollTimeout = null;

    $smallImgs.on('click', function () {
      if (scrollTimeout) clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(() => {
        const index = $(this).index();
        $smallImgs.removeClass('highlight');
        $(this).addClass('highlight');

        const $targetBigImg = $bigImgs.eq(index);
        const targetOffset = $targetBigImg[0].offsetTop;
        const containerHeight = $bigMediaBox.height();
        const scrollTo = targetOffset - (containerHeight / 2) + ($targetBigImg.height() / 2);

        $bigMediaBox.stop().animate({
          scrollTop: scrollTo
        }, 500);

        const windowHeight = $(window).height();
        const productDetailsTop = $productDetails.offset().top;
        const productDetailsBottom = productDetailsTop + $productDetails.outerHeight();

        if (index === 0) {
          $('html, body').stop().animate({
            scrollTop: productDetailsTop
          }, 500);
        } else if (index === $smallImgs.length - 1) {
          $('html, body').stop().animate({
            scrollTop: productDetailsBottom - windowHeight
          }, 500);
        }
      }, 100);
    });
  }
}

function linksaddclass() {
  $(document).ready(function () {
    var currentUrl = window.location.pathname;

    $('.two-cloumn-text .left-box a').each(function () {
      var linkUrl = $(this).attr('href').replace(/^https?:\/\/[^\/]+/, '');
      if (currentUrl === linkUrl) {
        $(this).parents('li').addClass('active');
      }
    });
  });
}

function emailchecked() {
  $(document).ready(function () {
    $("footer .form-group input").on("keydown", function (e) {
      if (e.keyCode === 9) {
        e.preventDefault();
        $("footer .form-group button").focus();
      }
    });
  });
}

function searchclick() {
  jQuery('body').on('click', '.header .header-right .search-button', function (e) {
    e.stopPropagation();
    if (jQuery(this).hasClass('is-click')) {
      closeSearchModal();
    } else {
      openSearchModal();
      jQuery('#Search-In-Modal').focus();
    }
  });

  jQuery('header .header .header__search .header-search-details .search-modal .search-modal__content predictive-search').on('click', function (e) {
    e.stopPropagation();
  });

  jQuery('body').on('click', function (e) {
    closeSearchModal();
  });

  jQuery('.header__search .search-modal .search-modal__content .modal__close-button.link').on('click', function (e) {
    closeSearchModal();
  });

  jQuery(document).on('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      closeSearchModal();
    }
  });

  function openSearchModal() {
    jQuery('.header .header-right .search-button').addClass('is-click');
    jQuery('.header__search').addClass('active');
    jQuery('html').addClass('overflow-hidden');
  }

  function closeSearchModal() {
    jQuery('.header .header-right .search-button').removeClass('is-click');
    jQuery('.header__search').removeClass('active');
    jQuery('html').removeClass('overflow-hidden');
  }
}

function pageInnerScroll() {
  // jQuery(document).on('click', '.yotpo-bottom-line-scroll-panel .yotpo-sr-bottom-line-button', function () {
  //   var sTop = jQuery('header').outerHeight();
  //   jQuery('html,body').animate({ scrollTop: jQuery(this.hash).offset().top - sTop }, 800);
  //   return false;
  // });

}

function isEmail(email) {
  var reg = /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/;
  if (reg.test(email)) {
    return true;
  } else {
    return false;
  }
}

function appHeight() {
  const doc = document.documentElement;
  doc.style.setProperty('--vh', (window.innerHeight * .01) + 'px');
}

window.addEventListener('resize', appHeight);
appHeight();